import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { HeartPulse, Bell, LogOut, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/Button';

export default function PatientLayout() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen bg-slate-50 font-inter">
            {/* Top Navbar */}
            <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-purple-100 shadow-sm print:hidden h-20 flex items-center">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex items-center justify-between">
                    <div className="flex items-center gap-6">
                        <Link to="/Screening_test/patient" className="flex items-center gap-3">
                            <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-md shrink-0">
                                <HeartPulse className="h-6 w-6" />
                            </div>
                            <div className="flex flex-col">
                                <span className="text-2xl font-black tracking-tight text-slate-900 font-outfit leading-none">MediBook</span>
                                <span className="text-[10px] font-black text-brand-600 uppercase tracking-widest mt-1">Screening Portal</span>
                            </div>
                        </Link>

                        {/* Link back to Main Portal */}
                        <a 
                            href="/dashboard"
                            className="hidden md:inline-flex items-center gap-2 text-xs font-bold text-slate-500 hover:text-brand-600 bg-slate-50 hover:bg-brand-50 border border-slate-200/60 hover:border-brand-200 px-3.5 py-1.5 rounded-xl transition-all"
                        >
                            <span>←</span> Health Panel
                        </a>
                    </div>

                    <div className="flex items-center gap-4 sm:gap-6">
                        {/* Notification Bell matching Image 2 */}
                        <div className="relative">
                            <button className="h-10 w-10 rounded-xl border border-purple-100 bg-white hover:bg-brand-50 text-brand-600 flex items-center justify-center transition-colors shadow-sm">
                                <Bell className="h-5 w-5" />
                                <span className="absolute top-2 right-2 h-2 w-2 rounded-full bg-brand-500 ring-2 ring-white"></span>
                            </button>
                        </div>

                        {/* Avatar Chip matching Image 2 */}
                        <div className="flex items-center gap-3 pl-3 sm:pl-5 border-l border-purple-100">
                            <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white font-extrabold text-sm shadow-md">
                                {user?.name ? user.name.trim().charAt(0).toUpperCase() : 'A'}
                            </div>
                            <div className="text-left hidden sm:block">
                                <p className="text-sm font-bold text-slate-900 leading-tight">{user?.name || 'User'}</p>
                                <p className="text-[11px] font-medium text-purple-400 capitalize">Patient</p>
                            </div>
                            <Button variant="ghost" size="icon" onClick={logout} className="h-9 w-9 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-all ml-1" title="Sign Out">
                                <LogOut className="h-4 w-4" />
                            </Button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 print:p-0 print:m-0 print:max-w-none print:w-full">
                <Outlet />
            </main>
        </div>
    );
}
